import React from 'react';
import { Helmet } from 'react-helmet-async';
import ChangeInsightsDetailsContainer from '../../../containers/change-insights/ChangeInsightsDetailsContainer.jsx';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';
import NotificationContainer from '../../../containers/notification/NotificationsContainer.jsx';
import { splitAndMapArrayParam } from '../../utils/index.js';

const ChangeInsightsSurvey = ({
  initiative,
  initiativeId,
  initiativeType,
  status,
  sentiment,
  changeInsightId,
  query,
}) => (
  <>
    <Helmet>
      <title>Feedback Results | ChangeSync</title>
    </Helmet>
    <ChangeInsightsDetailsContainer
      initiative={initiative}
      initiativeId={initiativeId}
      initiativeType={initiativeType}
      changeInsightId={changeInsightId}
      status={status}
      query={query}
      sentiment={sentiment}
    />
    <NotificationContainer />
  </>
);

const parseFilterParam = (value) => {
  if (typeof value !== 'string') return value;

  return value.split('/').map((v) => {
    if (v === 'none') return v;
    const num = Number(v);
    return isNaN(num) ? v : num;
  });
};

ChangeInsightsSurvey.getInitialProps = ({ query }) => ({
  query: {
    employeeIds: parseFilterParam(query.employeeIds),
    groupIds: parseFilterParam(query.groupIds),
    statuses: splitAndMapArrayParam(query.statuses),
    organizationStakeholderIds: parseFilterParam(
      query.organizationStakeholderIds
    ),
    participant: splitAndMapArrayParam(query.participant, Number),
    stakeholder: splitAndMapArrayParam(query.stakeholder, Number),
  },
});

export default requireAuth(withRouterParams(ChangeInsightsSurvey));
